document.addEventListener("DOMContentLoaded", function() {
    //Tab dans tous les produits, mettre sticky
  const headerBlock = document.querySelector('h1');
  const navProduits = document.querySelector('.tab-nav-produits');
  if ( headerBlock && navProduits) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Si l'élément est visible à 10% ou plus
        
        if (entry.isIntersecting) {        
          navProduits.classList.remove('active');
        } else {        
          navProduits.classList.add('active');
        }
      });
    }, {
      threshold: 0.5 // 0.1 correspond à 10% de visibilité
    });

    observer.observe(headerBlock);
  }

  //Tab dans tous les produits, activer les liens
  if (navProduits) {
    const section_vitoli = document.querySelector('.section-vitoli');
    const section_vitoli_link = document.querySelector('.section-vitoli-link');
    

    const observervitoli_link = new IntersectionObserver((entries) => {
      entries.forEach(entry => {        
        if (entry.isIntersecting) {     
          section_vitoli_link.classList.add('active');

        } else {        
          section_vitoli_link.classList.remove('active');

        }
      });
    }, {
      threshold: 0.1 // 0.1 correspond à 10% de visibilité
    });

    observervitoli_link.observe(section_vitoli);


    const section_base = document.querySelector('.section-base');
    const section_base_link = document.querySelector('.section-base-link');
    const observerbase_link = new IntersectionObserver((entries) => {
      entries.forEach(entry => {        
        if (entry.isIntersecting) {     
          section_base_link.classList.add('active');

        } else {        
          section_base_link.classList.remove('active');

        }
      });
    }, {
      threshold: 0.3 // 0.1 correspond à 10% de visibilité
    });

    observerbase_link.observe(section_base);




    const section_livre_link = document.querySelector('.section-livre-link');
    const section_livre = document.querySelector('.section-livre');
    const observerlivre_link = new IntersectionObserver((entries) => {
      entries.forEach(entry => {        
        if (entry.isIntersecting) {     
          section_livre_link.classList.add('active');

        } else {        
          section_livre_link.classList.remove('active');

        }
      });
    }, {
      threshold: 0.4 // 0.1 correspond à 10% de visibilité
    });

    observerlivre_link.observe(section_livre);

  
    const section_combo_link = document.querySelector('.section-combo-link');
    const section_combo = document.querySelector('.section-combo');
    const observercombo_link = new IntersectionObserver((entries) => {
      entries.forEach(entry => {        
        if (entry.isIntersecting) {     
          section_combo_link.classList.add('active');

        } else {        
          section_combo_link.classList.remove('active');

        }
      });
    }, {
      threshold: 0.3 // 0.1 correspond à 10% de visibilité
    });

    observercombo_link.observe(section_combo);


  }
  ////********** PAGE QUALITÉ VITOLI ****************///////////
  const nav_qualite = document.querySelector('.nav-qualite');
  const contenu_quantite = document.querySelector('.contenu-qualite');

if (nav_qualite) {
  // On observe la section JUSTE AVANT le menu
const section_precedente = document.querySelector('.text-intro-qv'); // Remplacez par le sélecteur du bloc au-dessus
//const nav_qualite = document.querySelector('.nav-qualite');

const observernav = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    // Si la section du haut n'est plus visible DU TOUT
    // ET qu'elle est sortie par le haut (boundingClientRect.top < 0)
    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
      nav_qualite.classList.add('sticky');
    } else {
      nav_qualite.classList.remove('sticky');
    }
  });
}, {
  threshold: 0, // Déclenche dès le dernier pixel
  rootMargin: "-60px 0px 0px 0px" 
});

observernav.observe(section_precedente);


  // //***Mettre actif formulation si visible */
  //  const formulation_link = document.querySelector('.formulation-link');
  //   const contenu_formulation = document.querySelector('.contenu-formulation');
  //   const observerformulation_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //       if (entry.isIntersecting) {     
  //         formulation_link.classList.add('active');

  //       } else {        
  //         formulation_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2 // 0.1 correspond à 10% de visibilité
  //   });

  //   observerformulation_link.observe(contenu_formulation);


  //   //***Mettre actif doseeffective si visible */
  //  const doseeffective_link = document.querySelector('.doseeffective-link');
  //   const contenu_doseeffective = document.querySelector('.contenu-doseeffective');
  //   const observerdoseeffective_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //           if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
    
  //         doseeffective_link.classList.add('active');
  //         formulation_link.classList.remove('active');


  //       } else {        
  //         doseeffective_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2, // 0.1 correspond à 10% de visibilité
  // rootMargin: "-290px 0px 0px 0px"

  //   });

  //   observerdoseeffective_link.observe(contenu_formulation);
   
   
   
  //   //***Mettre actif standardisation si visible */
  //  const standardisation_link = document.querySelector('.standardisation-link');
  //   const contenu_standardisation = document.querySelector('.contenu-standardisation');
  //   const observerstandardisation_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {   
  //         standardisation_link.classList.add('active');
  //         doseeffective_link.classList.remove('active');


  //       } else {        
  //         standardisation_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2, // 0.1 correspond à 10% de visibilité
  // rootMargin: "-290px 0px 0px 0px"

  //   });

  //   observerstandardisation_link.observe(contenu_doseeffective);
   
   
   
  //   //***Mettre actif tracabilite si visible */
  //  const tracabilite_link = document.querySelector('.tracabilite-link');
  //   const contenu_tracabilite = document.querySelector('.contenu-tracabilite');
  //   const observertracabilite_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //       if (entry.isIntersecting) {     
  //         tracabilite_link.classList.add('active');

  //       } else {        
  //         tracabilite_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2 // 0.1 correspond à 10% de visibilité
  //   });

  //   observertracabilite_link.observe(contenu_tracabilite);
   
   
   
  //   //***Mettre actif polyphenol si visible */
  //  const polyphenol_link = document.querySelector('.polyphenol-link');
  //   const contenu_polyphenol = document.querySelector('.contenu-polyphenol');
  //   const observerpolyphenol_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //       if (entry.isIntersecting) {     
  //         polyphenol_link.classList.add('active');

  //       } else {        
  //         polyphenol_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2 // 0.1 correspond à 10% de visibilité
  //   });

  //   observerpolyphenol_link.observe(contenu_polyphenol);
   


  //   //***Mettre actif recherches si visible */
  //  const recherches_link = document.querySelector('.recherches-link');
  //   const contenu_recherches = document.querySelector('.contenu-recherches');
  //   const observerrecherches_link = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {        
  //       if (entry.isIntersecting) {     
  //         recherches_link.classList.add('active');

  //       } else {        
  //         recherches_link.classList.remove('active');

  //       }
  //     });
  //   }, {
  //     threshold: 0.2 // 0.1 correspond à 10% de visibilité
  //   });

  //   observerrecherches_link.observe(contenu_recherches);

  const sections = [
  { link: '.formulation-link', content: '.contenu-formulation' },
  { link: '.doseeffective-link', content: '.contenu-doseeffective' },
  { link: '.standardisation-link', content: '.contenu-standardisation' },
  { link: '.tracabilite-link', content: '.contenu-tracabilite' }, // Ajoutez les autres ici
  { link: '.polyphenol-link', content: '.contenu-polyphenol' },
  { link: '.recherches-link', content: '.contenu-recherches' }
];
const observerOptions = {
  threshold: 0,
  // -200px en haut : déclenche quand l'élément atteint cette ligne
  // -75% en bas : ignore les éléments qui sont encore en bas de l'écran
  rootMargin: "-400px 0px -69% 0px"
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const sectionConfig = sections.find(s => document.querySelector(s.content) === entry.target);
    if (!sectionConfig) return;
    
    const linkEl = document.querySelector(sectionConfig.link);

    if (entry.isIntersecting) {
      // On retire 'active' de TOUS les liens pour n'en garder qu'un
      sections.forEach(s => document.querySelector(s.link).classList.remove('active'));
      linkEl.classList.add('active');
    } else {
      // Si on sort de la zone de 200px (vers le haut ou vers le bas)
      linkEl.classList.remove('active');
    }
  });
}, observerOptions);

sections.forEach(item => {
  const target = document.querySelector(item.content);
  if (target) observer.observe(target);
});

}///IF Nav qualité




});